import React from "react"
import loadingImage from "../../static/securemotor/images/loadingred.gif"

const Loader = () => {
  const style = {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    background: "black",
    opacity: "0.75",
    zIndex: "9999"
  }

  const loadingImageStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }

  return <div style={style}>
    <div>
      <img src={loadingImage} alt="loading.." style={loadingImageStyle} />
    </div>
  </div>
}

export default Loader